<template>
  <div class="courses">
    <div class="courses-list" v-for="(item, index) in courses" :key="index">
      <!-- fix issue #2378 -->
      <img
        :src="(item.cover ? item.cover.url : defaultImg) | handleImageUrl('228', '130')"
        class="section-img"
        @click="goPage(item)">
      <!-- fix issue #2007 -->
      <div :class="item.cover ? 'has-course-content' : 'no-course-content'">
        <!-- finish #2531 -->
        <div class="course-title" @click="goPage(item)" v-if="item.year">
          {{ (item.year ? item.year : item._source.year) + '年' + (item.title ? item.title : item._source.title) }}
        </div>
        <div class="course-title" @click="goPage(item)" v-else>{{ item.title ? item.title : item._source.title }}</div>
        <div class="course-label" v-if="item.status != 'NEW'">
          <div class="course-label-item hourse" v-if="item.hours == null">0课时</div>
          <div class="course-label-item hourse" v-else>{{ item.hours }}课时</div>
        </div>
        <div class="course-label-item" v-else>{{ item.plan_date }}更新</div>
      </div>
    </div>
  </div>
</template>
<script>
const StaticUrl = process.env.VUE_APP_CDN;
export default {
  props: {
    courses: {
      type: Array,
      default: () => [],
    },
    categoryTitle: {
      type: String,
      default: () => '',
    }
  },

  data() {
    return {
      defaultImg: StaticUrl + 'img-cover.jpg',
    }
  },
  methods: {
    goPage(item) {
      if (item.status == 'NEW') {
        alert('资料还在准备中，计划更新时间为：' + item.plan_date);
        return;
      }

      let href = `/course/view.html?id=${item.id ? item.id : item._source.id}&title=${item.title ? item.title : item._source.title}&categoryTitle=${this.categoryTitle}`;

      if (!this.isWechat()) {
        href += '&isShowHead=true';
      }
      window.location.href = href;
    }
  }
}
</script>
<style scoped>
.courses-list {
  display: flex;
  margin-top: 25px;
  padding: 0 25px;
  height: 130px;
  box-sizing: border-box;
}

.section-img {
  margin-right: 25px;
  width: 228px;
  height: 130px;
}

.has-course-content {
  width: 416px;
}

.no-course-content {
  width: 100%;
}
.course-title {
  margin-bottom: 15px;
  line-height: 40px;
  font-size: 30px;
  color: #000;
  font-weight: bold;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.course-label {
  display: flex;
  align-content: center;
  justify-content: space-between;
}

.course-label-item {
  font-size: 24px;
  color: #999;
}

.hourse {
  margin-right: 22px;
  color: #3e8dfd;
}
</style>
